import * as Color from "../../../../globalStyles/environmentColors";

export const controls = {
    textAlign: "center"
};

export const playerTitle = {
    backgroundColor: Color.accent,
    color: "white",
    minWidth: "80px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
};

export const playerDescription = {
    backgroundColor: Color.secondary,
    height: "100px",
    overflowY: "hidden",
    overflow: "auto"
};

export const statusBar = {
    backgroundColor: "lightgreen",
    height: "5px"
};

export const statusBarBackground = {
    backgroundColor: "black",
    height: "5px",
    padding: "0",
    cursor: "pointer"
};

export const playerScreen = {
    backgroundColor: "black",
    height: "100px"
};

export const playerTrackList = {
    height: "150px",
    overflowY: "hidden",
    overflow: "auto"
};

export const playerTrackDuration = {
    textAlign: "right"
};

export const trackCard = {
    backgroundColor: Color.primary,
    color: "white",
    cursor: "pointer"
};

export const durationTime = {
    textAlign: "right"
};

export const noTracksMessage = {
    textAlign: "center"
};
